import React from "react";
import { ArrowRight, LogIn, Sprout } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { useAuth } from "@/contexts/AuthContext";
import { PLATFORM_NAME } from "@/lib/polenica";

export default function LandingPage() {
  const navigate = useNavigate();
  const { user, isGuest, accessAsGuest } = useAuth();

  const handleEnter = () => {
    if (user || isGuest) {
      navigate("/inicio");
      return;
    }

    accessAsGuest();
    navigate("/inicio");
  };

  return (
    <div className="relative min-h-screen overflow-hidden bg-[#15231A]">
      <video
        className="absolute inset-0 h-full w-full object-cover"
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
      >
        <source src="/images/principal.mp4" type="video/mp4" />
      </video>

      <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(10,18,13,0.3)_0%,rgba(10,18,13,0.48)_48%,rgba(10,18,13,0.72)_100%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(246,233,189,0.12),transparent_34%)]" />

      <div className="relative flex min-h-screen flex-col px-6 py-6 sm:px-10 sm:py-8">
        <div className="flex items-start justify-between gap-4">
          <div className="inline-flex items-center gap-3 rounded-full border border-white/15 bg-white/10 px-4 py-2 text-white backdrop-blur-md">
            <Sprout className="h-5 w-5" />
            <span className="text-sm font-semibold tracking-[0.14em]">{PLATFORM_NAME}</span>
          </div>

          <button
            type="button"
            onClick={() => navigate("/login")}
            className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-4 py-2 text-sm font-semibold text-white backdrop-blur-md transition hover:bg-white/16"
          >
            <LogIn className="h-4 w-4" />
            Entrar con cuenta
          </button>
        </div>

        <div className="flex flex-1 items-center justify-center">
          <div className="max-w-4xl text-center text-white">
            <p className="text-sm font-semibold uppercase tracking-[0.34em] text-white/88">
              Huertas, pacas, saberes y comunidad
            </p>
            <h1 className="mt-6 font-heading text-4xl font-semibold leading-[1.04] sm:text-6xl lg:text-[5.1rem]">
              Un lugar para conectar con lo que ya está polinizando Medellín.
            </h1>
            <p className="mx-auto mt-6 max-w-3xl text-base leading-8 text-white/84 sm:text-lg">
              Recorra iniciativas, agenda, directorio y saberes vivos desde una misma red territorial abierta a la
              exploración.
            </p>

            <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
              <button
                type="button"
                onClick={handleEnter}
                className="inline-flex min-h-[76px] items-center gap-3 rounded-full border border-white/18 bg-primary px-10 py-5 font-heading text-2xl font-semibold text-white shadow-[0_24px_60px_rgba(12,18,13,0.35)] transition hover:scale-[1.02] hover:bg-[#46684C]"
              >
                Iniciar recorrido
                <ArrowRight className="h-6 w-6" />
              </button>

              <button
                type="button"
                onClick={() => navigate("/register")}
                className="inline-flex min-h-[58px] items-center gap-2 rounded-full border border-white/20 bg-white/10 px-7 py-4 text-sm font-semibold text-white backdrop-blur-md transition hover:bg-white/16"
              >
                Regístrese
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}
